import script from "./RecuperatePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./RecuperatePassword.vue?vue&type=script&setup=true&lang=js"

import "./RecuperatePassword.vue?vue&type=style&index=0&id=30b17c4e&lang=scss"

const __exports__ = script;

export default __exports__